export default {
  'page-title': 'Solicitud RMA - Creative Labs (España)',
  'page-desc': 'Para solicitar reemplazo en garantía(RMA), envíenos un correo electrónico.  ',
  'mode-of-contact': 'Modo de contacto',
  'your-details': 'Sus detalles',
  'rma-request': 'Solicitud RMA',
  'first-name': 'Nombre',
  'last-name': 'Apellido',
  'enter-first-name': 'Introduzca su nombre.',
  'enter-last-name': 'Introduzca su apelllido.',
  'email-address': 'Dirección de email',
  'enter-email': 'Introduzca su dirección de email.',
  'enter-valid-email': 'Introduzca una dirección de email válida.',
  'enter-pid': 'Please enter your personal ID',
  'super-x-fi': 'Super X-Fi',
  'products': 'Productos',
  'sale': 'Rebajas',
  'help': 'Ayuda',
  'sign-in': 'Registrarse',
  'account': 'Cuenta',
  'loading-page': 'CARGANDO...',
  'orders': 'Órdenes',
  'membership-program': 'Programa de afiliación',
  'account-profile': 'Perfil de cuenta',
  'contact-us': 'Contacte con nosotros',
  'sign-out': 'Desconectar',
  'recent-orders': 'Órdenes recientes',
  'view-all-orders': 'Ver todas las órdenes',
  'email_registered': {
    'text1': 'El email ya ha sido registrado ',
    'link': 'Registrarse',
    'text2': ' Recuperar historial de pedidos'
  },
  'country-region': 'País/Región',
  'select-country': 'Seleccione país.',
  'preferred-language': 'idioma preferido para respuesta',
  'select-language': 'Seleccione idioma.',
  'next': 'Siguiente',
  'encountered-error': 'Hemos encontrado un error. Inténtelo de nuevo.',
  'your-enquiry': 'Su consulta',
  'nature-enquiry': 'Naturaleza de su consulta',
  'order-number': 'Número de orden',
  'order-id': 'Order ID',
  'for-amazon-order': 'Para pedidos realizados a través de Amazon',
  'enter-order-number': 'Introduzca su número de orden.',
  'rma-number': 'Número de RMA',
  'enter-rma-number': 'Introduzca su número de RMA.',

  'purchase_creative_com': {
    'text': 'Si su producto defectuoso se compró en Creative.com ',
    'link': 'solicite un reemplazo aquí'
  },
  'not-purchase-creative-com': '<p>Si no ha hecho la compra directamente en creative.com, contacte con su vendedor para consultar las condiciones de devolución.</p><p><a href="https://es.creative.com/help/garant-a-y-devoluciones" target="_blank">Haga clic aquí para más información sobre garantía y devoluciones.</a></p>',
  'not-purchase-creative-com-retailer-replacement': 'Si no ha comprado en creative.com, diríjase directamente a su vendedor para consultas sobre el reemplazo.',
  'not_purchase_creative_com_2': {
    'text': 'Si su producto defectuoso no fue comprado directamente de Creative.com ',
    'link': 'solicite un reemplazo aquí'
  },

  'order-not-found': 'El número de pedido que ha ingresado no se encuentra en nuestros registros. Por favor, introduzca un número de pedido válido.',
  'rma-not-found': 'El número de RMA que ha ingresado no se encuentra en nuestros registros. Por favor, introduzca un número de RMA válido.',
  'previous-order': 'Orden anterior',
  'next-order': 'Orden siguiente',
  'add-your-product': 'Añada su producto',
  'search-by-name': 'Busque por nombre de producto',
  'select-product': 'Seleccione el producto.',
  'upload-proof-update-date': {
    'text1': 'Facilite su prueba de compra y la fecha de compra. <br/>Si no tiene su prueba de compra,  ',
    'link': 'contáctenos ',
    'text2': ' aquí.'
  },
  'return-product': 'Devolver producto',
  'return-products': 'Devolver producto(s)',
  'replace-defective-product': 'Reemplazar producto defectuoso',
  'check-rma-status': 'Comprobar estado de RMA',
  'service-request': 'Solicitud(es) de servicio disponible(s)',
  'select-one-service': 'Seleccione una solicitud de servicio. Si tiene más de una solicitud de servicio para la misma orden, cree una solicitud de servicio diferente para cada incidencia.',
  'select-one-servcie-2': 'Seleccione una solicitud de servicio.',
  'refund-products': 'Reembolso de producto(s)',
  'qualifies-refund': 'Solo {refundNotAvailable} califica para un reembolso bajo la Garantía de Satisfacción. <> Edite sus productos antes de continuar.',
  'replace-products': 'Reemplazo de producto(s) defectuoso(s)',
  'qualifies-replace': 'Solo {repairNotAvailable} califica para un reemplazo. <> Edite sus productos antes de continuar.',
  'contact-us-assistance': 'Contáctenos para asistencia',
  'return-information': 'Información de devolución',
  'replacement-information': 'Información de reemplazo',
  'fill-in-all': 'Rellene todos los campos en esta sección.',
  'message': 'Mensaje',
  'enter-message': 'Introduzca su mensaje',
  'submit': 'Enviar',
  'submission-successful': 'Su comunicación se ha enviado. ',
  'contact-us-thank-you': 'Le responderemos dentro de los proximos 2 días laborables.',
  'back-to-home': 'Volver a inicio',
  'confirmation': 'Confirmación',
  'rma-confirmation': 'Confirmación de RMA',
  'refresh-page': 'Actualizar',
  'loading': 'Cargando...',
  'select': 'Seleccione dirección',
  'selected': 'Seleccionado',
  'update': 'Editar dirección',
  'address': 'Address',
  'new-address': 'Nueva dirección',
  'edit': 'Editar',
  'update-address': 'Actualizar dirección',
  'cancel': 'Cancelar',
  'back': 'Volver',
  'select-your-products': 'Seleccione su(s) producto(s))',
  'serial-number': 'Número de serie',
  'returns-eligibility': 'Criterios de devolución',
  'warranty': 'Garantía',
  'proof-purchase': 'Prueba de compra',
  'purchase-date': 'Fecha de compra',
  'select-date': 'Fecha de compra',
  'how-find-serial-num': '¿Cómo encontrar el número de serie?',
  'yes': 'Sí',
  'no': 'No',
  'choose-file': 'Elegir archivo',
  'upload-supporting-file': 'Cargar imagen de soporte',
  'remove': 'Eliminar',
  'warranty-days-left': 'Queda(n) {warrantyDaysRemain} día(s)',
  'out-warranty': 'Fuera de garantía',
  'enter-serial': 'Introduzca número de serie',
  'enter-serial-number': 'Introduzca un número de serie válido',
  'serial-not-valid': 'Introduzca un número de serie válido.',
  'serial-num-submitted': 'Este número de serie ya se ha enviado, cámbielo.',
  'file-formats-allowed': 'Formatos de archivo permitidos: JPG, PNG, ZIP Máximo tamaño: 4 MB.',
  'thank-you-rma-submit': 'Gracias por su solicitud de RMA',
  'provide-rma-number': 'Proporcione su número de RMA a nuestro Equipo de Servicio al Cliente si nos contacta con respecto a este RMA.',
  'retrieve_rma_status': {
    'text': 'También puede obtener su estado de RMA o hacer cambios a su RMA registrándose para una ',
    'link': 'cuenta de la tienda Creative'
  },
  'product-details': 'Detalles del producto',
  'product': 'Producto',
  'rma-details': 'Detalles de RMA',
  'service-request2': 'Solicitud de servicio',
  'refund': 'Reembolso',
  'replacement': 'Reemplazo',
  'rma-status': 'Estado de RMA',
  'expires-date': 'Caduca {date}',
  'refund-estimated-cost': 'Nota: El total del reembolso es actualmente una estimación y puede estar sujeto a cambios adicionales.',
  'service-fee': 'Tasa de servicio',
  'service-fee-text': 'Se puede cobrar una tarifa de servicio si su producto devuelto muestra signos de daño accidental o abuso. Será contactado por correo electrónico si esto es aplicable.',
  'product-is-defective': 'El producto es defectuoso',
  'repair-status-list': [
    {
      'status': 'Solicitud de RMA recibida',
      'desc': '<p>Su solicitud de RMA está siendo procesada.</p><p><i>(Normalmente lleva entre 1 y 2 días laborables)</i></p>'
    },
    {
      status: 'RMA aprobada',
      desc: `<p>Envíenos su producto de vuelta. </p><p><i>(Normalmente lleva entre 1 y 2 días laborables)</i></p>
              <span style="font-weight: 500;">Ver instrucciones de devolución.</span>
              <div class="return-instruction">
                <div id="display_eu" style="display:{display_eu}">
                  Refiérase al correo electrónico (Asunto: su solicitud de devolución de Creative Labs ha sido aprobada) para obtener las instrucciones de devolución.
                  Puede generar la etiqueta de envío para la devolución a través del siguiente enlace e introducir la información como se indica:
                  <p style="margin:10px auto">
                    URL: <a href="{courierLabelLink}" target="_blank">{courierLabelLink}</a> <br>
                    Número de orden:  <span style='font-weight:500'>{orderNumber}</span> <br>
                    Código de retorno:   <span style='font-weight:500'>{b2cTrackingNumber}</span> <br>
                  </p>
                  <p>
                  Tenga en cuenta que una vez que se haya usado la etiqueta de envío, no será posible usarla de nuevo.
                  </p>
                </div>

                <div id="display_others" style="display:{display_others}">
                  Refiérase al correo electrónico (Asunto: su solicitud de devolución de Creative Labs ha sido aprobada) para obtener las instrucciones de devolución.
                  <p id="display_shippingLabel1" style="margin:10px auto;{display_shippingLabel}">
                    Su etiqueta de envío debe descargarse dentro de estos 90 días.
                    Una vez que se accede a la etiqueta por primera vez, debe descargarse o imprimirse dentro de los 5 días siguientes, después de lo cual ya no será accesible.<br>
                    <a href="{courierLabelLink}" target="_blank" style="text-decoration:underline">Etiqueta de envío</a>
                  </p>
                  <p id="display_shippingLabel2" style="margin:10px auto;{display_shippingLabel}">
                  Tenga en cuenta que una vez que se haya usado la etiqueta de envío, no será posible usarla de nuevo.
                  </p>
                </div>
            </div>`
    },
    {
      status: 'Producto recibido',
      desc: '<p>Estamos verificando su producto devuelto.</p><p><i>(Normalmente lleva entre 1 y 2 días laborables)</i></p>',
    },
    {
      status: 'Preparando reemplazo',
      desc: '<p>Estamos comprobando la disponibilidad de stock de su unidad de reemplazo.</p><p><i>(Normalmente lleva entre 1 y 2 días laborables)</i></p>',
    },
    {
      status: 'Preparando el envío',
      desc: '<p>Estamos preparando su unidad de reemplazo para enviarla.</p><p><i>(Normalmente lleva entre 1 y 2 días laborables)</i></p>',
    },
    {
      status: 'Reemplazo enviado',
      desc: '<p>Su unidad de reemplazo se ha enviado.  <br />  </p>',
    }
  ],
  'refund-status-list': [
    {
      'status': 'Solicitud de RMA recibida',
      'desc': '<p>Su solicitud de RMA está siendo procesada.</p><p><i>(Normalmente lleva entre 1 y 2 días laborables)</i></p>'
    },
    {
      status: 'RMA aprobada',
      desc: `<p>Envíenos su producto de vuelta. </p><p><i>(Normalmente lleva entre 1 y 2 días laborables)</i></p>
              <span style="font-weight: 500;">Ver instrucciones de devolución.</span>
              <div class="return-instruction">
                <div id="display_eu" style="display:{display_eu}">
                  Refiérase al correo electrónico (Asunto: su solicitud de devolución de Creative Labs ha sido aprobada) para obtener las instrucciones de devolución.
                  Puede generar la etiqueta de envío para la devolución a través del siguiente enlace e introducir la información como se indica:
                  <p style="margin:10px auto">
                    URL: <a href="{courierLabelLink}" target="_blank">{courierLabelLink}</a> <br>
                    Número de orden:  <span style='font-weight:500'>{orderNumber}</span> <br>
                    Código de retorno:   <span style='font-weight:500'>{b2cTrackingNumber}</span> <br>
                  </p>
                  <p>
                  Tenga en cuenta que una vez que se haya usado la etiqueta de envío, no será posible usarla de nuevo.
                  </p>
                </div>

                <div id="display_others" style="display:{display_others}">
                  Refiérase al correo electrónico (Asunto: su solicitud de devolución de Creative Labs ha sido aprobada) para obtener las instrucciones de devolución.
                  <p id="display_shippingLabel1" style="margin:10px auto;{display_shippingLabel}">
                    Su etiqueta de envío debe descargarse dentro de estos 90 días.
                    Una vez que se accede a la etiqueta por primera vez, debe descargarse o imprimirse dentro de los 5 días siguientes, después de lo cual ya no será accesible.<br>
                    <a href="{courierLabelLink}" target="_blank" style="text-decoration:underline">Etiqueta de envío</a>
                  </p>
                  <p id="display_shippingLabel2" style="margin:10px auto;{display_shippingLabel}">
                  Tenga en cuenta que una vez que se haya usado la etiqueta de envío, no será posible usarla de nuevo.
                  </p>
                </div>
            </div>`
    },
    {
      status: "Producto recibido",
      desc: "<p>Estamos verificando su producto devuelto.</p><p><i>(Normalmente lleva entre 1 y 2 días laborables)</i></p>",
    },
    {
      status: "Procesando el reembolso",
      desc: "<p>Su producto se ha verificado y estamos procesando su reembolso<span style='{showAmount}'> de <strong>{RefundAmtActual}</strong> €</span>.</p><p><i>(Normalmente lleva entre 3 y 5 días laborables)</i></p>",
    },
    {
      status: "Reembolso completado",
      desc: "<p>Hemos completado el reembolso a través de su método original de pago. Este proceso puede llevarle a su banco hasta 30 días. Contacte con su banco para más información.</p><p><i>(Podría llevar hasta 30 días que su banco procese la recepción del reembolso.)</i></p>",
    }
  ],
  'what-are-reason': '¿Cuál es el motivo de su devolución?',
  'which-part-defective': '¿Qué parte de su producto está defectuoso?',
  'please-select-one': 'Seleccione uno.',
  'cosmetic-damages': '¿Hay algún daño físico/cosmético en el producto?',
  'attach-photo': 'Adjunte fotos de los daños:',
  'comments': 'Comentarios',
  'enter-comments': 'Introduzca una descripción detallada de la consulta.',
  'rma-exists': 'Se ha enviado una solicitud de RMA para este producto.',
  'rma-created': 'Ya existe una solicitud de RMA para este producto y no puede crearse otra vez.',
  'rma-cancelled': 'Su solicitud de RMA se ha cancelado. Si tiene alguna consulta respecto a este cancelación, contacte con nosotros.',
  'selected-maximum': 'Ha seleccionado la máxima cantidad permitida.',
  'shipping-information': 'Información de envío',
  'shipping-address': '	Dirección de envío',
  'select-shipping-address': 'Seleccione una dirección de envío',
  'replace-sent-address': 'Su reemplazo será enviado a la siguiente dirección de envío.  ',
  'product-purchased-from': 'Producto adquirido en',
  'creative-store': 'Tienda de Creative',
  'all-other-retailers': 'Otros minoristas',
  'product-not-received': 'No recibido',
  'product-cancelled': 'Cancelada',
  'rma-closed': 'Cerrar',
  'select-mode-of-contact': 'Seleccione su modo de contacto con nosotros.',
  'email-us': 'Envíenos un correo electrónico',
  'your-order': 'Su pedido',
  'refund-amount': 'Total del reembolso',
  'shipping-charge': 'Coste del envío',
  'store-credit': 'Créditos de tienda',
  'tax': 'Impuesto',
  'deliver-unable-info':'No realizamos entregas en apartados de correos, hoteles, moteles y los siguientes territorios de ultramar. <a href="/help/entrega#what-are-the-overseas-territories-that-you-don-39-t-deliver-to" target="_blank">Saber más</a>.',
  'creative-in-warranty': '',
  'extended-warranty': '',
  'maintenance-msg': `Aviso: Nuestra página web va a efectuar un mantenimiento programado para mejorar el servicio. El mantenimiento está previsto para el domingo 9 de octubre de 2022 de 9:00 am a 3:00 pm (GMT +8: 00). Durante este tiempo, nuestros sitios web no serán accesibles.
  <br><br>
  Nos disculpamos por las molestias causadas. Gracias por su paciencia.`,
  'shipping-country-notice-es': 'Este sitio web solo realiza envíos a España y excluye todos los territorios de ultramar como las Islas Canarias y Melilla. Tampoco podemos enviar a apartados de correos, taquillas, hoteles, moteles y más. <a href="/help/entrega#-a-d-nde-realizar-los-env-os" target="_blank">Saber más</a>.'
}
